import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { AlertCircle } from 'lucide-react';
export function UrgencyBar() {
  return <div className="sticky top-0 z-50 bg-gradient-to-r from-blue-700 via-cyan-600 to-blue-700 text-white shadow-lg" data-id="element-29">
      <div className="max-w-6xl mx-auto px-4 py-2 flex flex-col sm:flex-row items-center justify-between gap-2 sm:gap-4" data-id="element-30">
        <div className="flex items-center gap-2 text-center sm:text-left" data-id="element-31">
          <AlertCircle className="w-5 h-5 text-yellow-300 animate-pulse hidden sm:block" data-id="element-32" />
          <p className="font-medium text-sm sm:text-base" data-id="element-33">
            <span className="font-bold text-yellow-300" data-id="element-34">¡OFERTA FLASH!</span>{' '}
            Solo quedan{' '}
            <span className="font-bold underline decoration-yellow-300 decoration-2" data-id="element-35">
              7 copias
            </span>{' '}
            con descuento
          </p>
        </div>

        <div className="flex items-center gap-3 scale-75 sm:scale-90 origin-right" data-id="element-36">
          <span className="text-xs font-bold uppercase tracking-wider opacity-90 hidden sm:inline" data-id="element-37">
            Termina en:
          </span>
          <CountdownTimer variant="light" className="text-blue-900" data-id="element-38" />
        </div>
      </div>
    </div>;
}